<script lang="ts">
	const { accountId }: { accountId?: string } = $props();
</script>

<svelte:head>
	{#if accountId}
		{@html `
		<script async src="https://www-ads.gembiratech.com/php/pixel.js.php"></script>
		`}
	{/if}
</svelte:head>
